import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const buttonBaseDefaultVariants = {
  "padding": "default",
  "size": "md",
  "fullWidth": false
}
const buttonBaseCompoundVariants = [
  {
    "padding": "default",
    "size": "xl",
    "css": {
      "root": {
        "pl": "{spacing.button.size.xl.paddingX}",
        "pr": "{spacing.button.size.xl.paddingX}",
        "py": "{spacing.button.size.xl.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.xl.paddingXWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.xl.paddingXWithIcon}"
        }
      }
    }
  },
  {
    "padding": "default",
    "size": "lg",
    "css": {
      "root": {
        "pl": "{spacing.button.size.lg.paddingX}",
        "pr": "{spacing.button.size.lg.paddingX}",
        "py": "{spacing.button.size.lg.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.lg.paddingXWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.lg.paddingXWithIcon}"
        }
      }
    }
  },
  {
    "padding": "default",
    "size": "md",
    "css": {
      "root": {
        "pl": "{spacing.button.size.md.paddingX}",
        "pr": "{spacing.button.size.md.paddingX}",
        "py": "{spacing.button.size.md.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.md.paddingXWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.md.paddingXWithIcon}"
        }
      }
    }
  },
  {
    "padding": "default",
    "size": "sm",
    "css": {
      "root": {
        "pl": "{spacing.button.size.sm.paddingX}",
        "pr": "{spacing.button.size.sm.paddingX}",
        "py": "{spacing.button.size.sm.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.sm.paddingXWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.sm.paddingXWithIcon}"
        }
      }
    }
  },
  {
    "padding": "default",
    "size": "xs",
    "css": {
      "root": {
        "pl": "{spacing.button.size.xs.paddingX}",
        "pr": "{spacing.button.size.xs.paddingX}",
        "py": "{spacing.button.size.xs.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.xs.paddingXWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.xs.paddingXWithIcon}"
        }
      }
    }
  },
  {
    "padding": "narrow",
    "size": "xl",
    "css": {
      "root": {
        "pl": "{spacing.button.size.xl.paddingXNarrow}",
        "pr": "{spacing.button.size.xl.paddingXNarrow}",
        "py": "{spacing.button.size.xl.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.xl.paddingXNarrowWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.xl.paddingXNarrowWithIcon}"
        }
      }
    }
  },
  {
    "padding": "narrow",
    "size": "lg",
    "css": {
      "root": {
        "pl": "{spacing.button.size.lg.paddingXNarrow}",
        "pr": "{spacing.button.size.lg.paddingXNarrow}",
        "py": "{spacing.button.size.lg.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.lg.paddingXNarrowWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.lg.paddingXNarrowWithIcon}"
        }
      }
    }
  },
  {
    "padding": "narrow",
    "size": "md",
    "css": {
      "root": {
        "pl": "{spacing.button.size.md.paddingXNarrow}",
        "pr": "{spacing.button.size.md.paddingXNarrow}",
        "py": "{spacing.button.size.md.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.md.paddingXNarrowWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.md.paddingXNarrowWithIcon}"
        }
      }
    }
  },
  {
    "padding": "narrow",
    "size": "sm",
    "css": {
      "root": {
        "pl": "{spacing.button.size.sm.paddingXNarrow}",
        "pr": "{spacing.button.size.sm.paddingXNarrow}",
        "py": "{spacing.button.size.sm.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.sm.paddingXNarrowWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.sm.paddingXNarrowWithIcon}"
        }
      }
    }
  },
  {
    "padding": "narrow",
    "size": "xs",
    "css": {
      "root": {
        "pl": "{spacing.button.size.xs.paddingXNarrow}",
        "pr": "{spacing.button.size.xs.paddingXNarrow}",
        "py": "{spacing.button.size.xs.paddingY}",
        "&[data-has-start-icon]": {
          "pl": "{spacing.button.size.xs.paddingXNarrowWithIcon}"
        },
        "&[data-has-end-icon]": {
          "pr": "{spacing.button.size.xs.paddingXNarrowWithIcon}"
        }
      }
    }
  }
]

const buttonBaseSlotNames = [
  [
    "root",
    "buttonBase__root"
  ],
  [
    "icon",
    "buttonBase__icon"
  ],
  [
    "startIcon",
    "buttonBase__startIcon"
  ],
  [
    "endIcon",
    "buttonBase__endIcon"
  ],
  [
    "spinner",
    "buttonBase__spinner"
  ]
]
const buttonBaseSlotFns = /* @__PURE__ */ buttonBaseSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, buttonBaseDefaultVariants, getSlotCompoundVariant(buttonBaseCompoundVariants, slotName))])

const buttonBaseFn = memo((props = {}) => {
  return Object.fromEntries(buttonBaseSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const buttonBaseVariantKeys = [
  "size",
  "padding",
  "fullWidth"
]
const getVariantProps = (variants) => ({ ...buttonBaseDefaultVariants, ...compact(variants) })

export const buttonBase = /* @__PURE__ */ Object.assign(buttonBaseFn, {
  __recipe__: false,
  __name__: 'buttonBase',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: buttonBaseVariantKeys,
  variantMap: {
  "size": [
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
  ],
  "padding": [
    "default",
    "narrow"
  ],
  "fullWidth": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, buttonBaseVariantKeys)
  },
  getVariantProps
})